import React, { useState } from "react";
import {
  Box,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Close, Dashboard, Fullscreen, Remove } from "@material-ui/icons";

export const CONECTHUB360_DEFAULT_DASHBOARD_URL =
  "https://app.conecthub360.com.br/dashboard";

const useStyles = makeStyles((theme) => ({
  conecthubBackdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1299,
  },
  conecthubShell: {
    position: "fixed",
    zIndex: 1300,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    transition: theme.transitions.create(
      ["width", "height", "top", "left", "bottom", "right"],
      {
        duration: theme.transitions.duration.shortest,
      }
    ),
  },
  conecthubShellExpanded: {
    top: "10vh",
    left: "10vw",
    width: "80vw",
    height: "80vh",
  },
  conecthubShellMinimized: {
    top: "auto",
    left: "auto",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    width: 320,
    maxWidth: "calc(100vw - 16px)",
    height: 48,
  },
  conecthubPaper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    overflow: "hidden",
    borderRadius: theme.shape.borderRadius,
  },
  conecthubHeader: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    minHeight: 48,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  conecthubTitle: {
    flex: 1,
    marginRight: theme.spacing(1),
    fontWeight: 600,
  },
  conecthubIframeWrap: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
  },
  conecthubIframe: {
    width: "100%",
    flex: 1,
    minHeight: 0,
    border: "none",
    display: "block",
  },
}));

/**
 * Mesmo modal usado em Conexões: iframe do ConectHUB 360 (URL configurável).
 */
function Conecthub360Modal({
  open,
  onClose,
  iframeSrc = CONECTHUB360_DEFAULT_DASHBOARD_URL,
}) {
  const classes = useStyles();
  const [minimized, setMinimized] = useState(false);

  if (!open) {
    return null;
  }

  const handleClose = () => {
    setMinimized(false);
    onClose();
  };

  return (
    <>
      {!minimized ? (
        <div className={classes.conecthubBackdrop} role="presentation" />
      ) : null}
      <div
        className={`${classes.conecthubShell} ${
          minimized
            ? classes.conecthubShellMinimized
            : classes.conecthubShellExpanded
        }`}
      >
        <Paper className={classes.conecthubPaper} elevation={12}>
          <Box className={classes.conecthubHeader}>
            <Dashboard
              fontSize="small"
              style={{ color: "#7c3aed", marginRight: 8, flexShrink: 0 }}
            />
            <Typography
              variant="subtitle1"
              component="span"
              className={classes.conecthubTitle}
              noWrap
            >
              ConectHUB 360
            </Typography>
            {!minimized ? (
              <Tooltip title="Minimizar">
                <IconButton
                  aria-label="Minimizar"
                  onClick={() => setMinimized(true)}
                  size="small"
                >
                  <Remove />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Ampliar">
                <IconButton
                  aria-label="Ampliar"
                  onClick={() => setMinimized(false)}
                  size="small"
                >
                  <Fullscreen />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Fechar">
              <IconButton aria-label="Fechar" onClick={handleClose} size="small">
                <Close />
              </IconButton>
            </Tooltip>
          </Box>
          <Box
            className={classes.conecthubIframeWrap}
            style={{ display: minimized ? "none" : "flex" }}
          >
            <iframe
              title="ConectHUB 360"
              src={iframeSrc}
              className={classes.conecthubIframe}
              allow="clipboard-read; clipboard-write; fullscreen"
            />
          </Box>
        </Paper>
      </div>
    </>
  );
}

export default Conecthub360Modal;
